@if (isInitialized()) {
  <div class="vflex-200 scrollable">
    @if (showLabel()) {
      <p class="medium">Enter time</p>
    }
    <div class="hflex-200 flex-align-items-start">
      <div class="vflex-075">
        <div class="hflex-000 flex-align-items-center pad-050">
          <div>
            <input
              mdwTwoDigitNumber
              type="text"
              placeholder="3"
              data-pw="hour-input"
              [ngModel]="hours()"
              [ngModelOptions]="{ standalone: true }"
              [maxValue]="12"
              (keydown)="handleKeydown($event)"
              (ngModelChange)="updateTime($event)"
            />
          </div>
          <div class="spacer hflex-000 flex-align-items-center flex-justify-content-center">
            <p>:</p>
          </div>
          <div>
            <input
              mdwTwoDigitNumber
              type="text"
              placeholder="00"
              data-pw="minute-input"
              [padSingleDigits]="true"
              [maxValue]="59"
              [ngModel]="minutes()"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateTime(undefined, $event)"
              (keydown)="handleKeydown($event)"
            />
          </div>
        </div>
        <div class="hflex-000 flex-align-items-center">
          <p class="extra-small secondary time-label hpad-100">Hour</p>
          <p class="spacer"></p>
          <p class="extra-small secondary time-label hpad-100">Minute</p>
        </div>
      </div>
      <mdw-tab-group
        orientation="vertical"
        [class.small-tab-group]="size() === 'small'"
        [tabs]="[
          { label: 'AM', alias: 'AM' },
          { label: 'PM', alias: 'PM' },
        ]"
        [selectedTab]="isAm() ? 'AM' : 'PM'"
        (goTo)="handleToggleAmPm($event)"
      ></mdw-tab-group>
    </div>
  </div>
}
